import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@material-ui/styles'
import { createTheme } from '@material-ui/core/styles'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import "./layout.css"
import { LoggedInContextProvider } from '../components/context'

const theme = createTheme({
  palette: {
    primary: {
      main: '#00a3c1'
    },
    secondary: {
      main: '#e3622f'
    }
  }
})

const Layout = ({ children }) => (
  <ThemeProvider theme={theme}>
    <LoggedInContextProvider>
      <Navbar/>
      {children}
      <Footer />
    </LoggedInContextProvider>
  </ThemeProvider>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
